import { InfoCircleOutlined, PlusOutlined } from "@ant-design/icons";
import { Divider } from "antd";
import React from "react";
import { Button } from "react-bootstrap";
import { formatCurrency } from "../../modules/formatCurrency";
import { useTranslation } from "react-i18next";

export const AddOnServices = (props) => {
  const {
    currency,
    convertAmount,
    branding,
    showAddOnServices,
    toggleAddOnServices,
    addonservices,
    handleShowServiceModal,
    handlePickAddOnService,
  } = props;
  const { t } = useTranslation();
  return (
    <div className="col-md-12 mt-2">
      <h5 style={{ color: "#443d80" }}>
        <Button
          variant="link"
          onClick={toggleAddOnServices}
          style={{ padding: "0", fontSize: "16px" }}
        >
          <strong>{t("room.add_on_services")}</strong>{" "}
          {showAddOnServices ? "▲" : "▼"}
        </Button>
      </h5>
      {showAddOnServices && addonservices && addonservices.length > 0 ? (
        addonservices.map((service, index) => (
          <React.Fragment key={index}>
            <div
              className="d-flex align-items-center"
              style={{ marginBottom: "5px", color: "white" }}
            >
              <div className="col-md-2 ">
                {service.photo ? (
                  <img
                    src={service.photo}
                    alt={service.serviceName}
                    style={{
                      width: "100px",
                      height: "100px",
                      objectFit: "cover",
                      borderRadius: "5px",
                    }}
                  />
                ) : (
                  <p>No photo available</p>
                )}
              </div>
              <div className="col-md-6">
                <p
                  className="add-on"
                  style={{
                    fontSize: "18px",
                    fontFamily: "Comfortaa",
                    marginLeft: "10px",
                    textJustify: "inter-word",
                  }}
                >
                  <strong>{service.serviceName}</strong>
                  <p
                    className="add-on-info"
                    style={{
                      fontSize: "12px",
                      fontStyle: "italic",
                      color: "#fff",
                      marginBottom: "8px",
                    }}
                  >
                    <span>
                      <InfoCircleOutlined
                        className="add-on-info"
                        style={{
                          color: "#fff",
                          fontSize: "15px",
                          marginRight: "5px",
                        }}
                      />
                      {service.serviceDescription}
                    </span>{" "}
                    <br />
                    <span
                      className="add-on-info"
                      onClick={() => handleShowServiceModal(service)}
                      style={{
                        fontSize: "15px",
                        fontStyle: "italic",
                        marginTop: "6px",
                        textDecoration: "underline",
                        color: "#fff",
                        cursor: "pointer",
                      }}
                      onMouseEnter={(e) => (e.target.style.color = "#E9A6FF")}
                      onMouseLeave={(e) => (e.target.style.color = "#fff")}
                    >
                      <InfoCircleOutlined
                        className="add-on-info"
                        style={{
                          color: "#fff",
                          fontSize: "16px",
                          marginRight: "5px",
                        }}
                      />
                      {t("room.more_info")}
                    </span>
                  </p>
                </p>
              </div>
              <div className="ms-auto d-flex align-items-center">
                <p
                  className="add-on-price"
                  style={{
                    fontSize: "20px",
                    fontFamily: "UTM Bebas",
                    color: "#fff",
                    marginRight: "8px",
                  }}
                >
                  <strong>
                    {formatCurrency({
                      amount: service.servicePrice,
                      currency,
                      convertAmount,
                    })}{" "}
                  </strong>
                  <p
                    style={{
                      fontSize: "15px",
                      fontFamily: "UTM Bebas",
                      color: "#fff",
                      marginRight: "8px",
                    }}
                  >
                    ({service.chargeType})
                  </p>
                </p>
                <Button
                  variant="success"
                  className="pick-button mb-4"
                  onClick={() => handlePickAddOnService(service)}
                  style={{
                    backgroundColor: branding.buttonColor,
                    borderColor: branding.buttonColor,
                  }}
                >
                  <PlusOutlined />
                </Button>
              </div>
            </div>
            <Divider style={{ margin: "8px 0" }} />
          </React.Fragment>
        ))
      ) : (
        <i
          style={{
            fontSize: "13px",
            fontStyle: "italic",
            color: "#fff",
            marginBottom: "15px",
          }}
        >
          {t("homescreen.view_add_on_services")}.
        </i>
      )}
    </div>
  );
};
